import React, {Component} from 'react';
import Slider from 'react-slick';
import _ from 'lodash';
import {css} from 'glamor';
import PreloadImage from '../components/PreloadImage';

const splashContainer = css({
  display: 'flex',
  alignItems: 'center',
  height: '100%'
});

const sliderItem = css({
  display: 'flex',
  alignItems: 'center',
  height: '100%',
});

const sliderItemImage = css({
  width: '100%',
  minHeight: '100%',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center center',
  backgroundAttachment: 'fixed',
  backgroundSize: 'cover',
  pointerEvents: 'none',
});

class SplashSlider extends Component {

  render() {
    const images = this.props.images;
    const settings = {
      dots: true,
      fade: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: false,
      className: 'splash-slider',
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: false
    };
    return (
      <Slider {...settings} ref={(s) => this.slider = s}>
        {
          _.map(images, (photo, i) => {
            return (
              <div key={photo.file.url} {...sliderItem}>
                <PreloadImage backgroundImage={true} styles={sliderItemImage} src={photo.file.url}/>
              </div>
            );
          })
        }
      </Slider>
    );
  }

}

const IndexPage = ({data}) => {
  const images = _.get(data, 'allContentfulSplashPage.edges[0].node.images');
  return (
    <div {...splashContainer}>
      <SplashSlider images={images}/>
    </div>
  );
}

export default IndexPage

export const query = graphql`
  query HomeQuery {
    allContentfulSplashPage {
      edges {
        node {
          title
          images {
            file {
              url
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js